import { VList } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{attrs:{"id":"list","two-line":_vm.twoLine}},[_c('header',{staticClass:"pa-4 list-header"},[_vm._v(" "+_vm._s(_vm.header)+" "),(_vm.showCounter)?_c('span',[_vm._v("("+_vm._s(_vm.counter)+")")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }